import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaChalkboardTeacher, FaGlobe, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';

const AdmissionPage = () => {
  return (
    <>
      <Navbar />

      {/* Hero Section with Background */}
      <section className="relative px-6 py-24 text-white bg-gradient-to-r from-blue-900 to-blue-700">
        <div className="mx-auto text-center max-w-7xl">
          <h1 className="mb-6 text-5xl font-bold animate-fade-in-down">Now Accepting Admissions 🎓</h1>
          <p className="max-w-2xl mx-auto text-xl animate-fade-in-up">
            Join <strong>Blessed Montessori</strong> and give your child an excellent foundation through quality education, moral discipline, and modern learning tools.
          </p>
          <button
            onClick={() => window.location.href = '/admission-form'}
            className="px-8 py-4 mt-8 font-semibold text-blue-900 transition-all bg-yellow-400 rounded-lg shadow-md hover:bg-yellow-500 animate-bounce"
          >
            Apply Now
          </button>
        </div>
      </section>

      {/* Principal's Welcome */}
      <section className="px-6 py-16 bg-white dark:bg-gray-900">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">A Message from the Principal</h2>
          <p className="max-w-3xl mx-auto mt-6 italic text-gray-700 dark:text-gray-300">
            “At Blessed Montessori, we believe in raising future leaders. Our doors are open to families who value academic excellence, personal growth, and a secure environment for their children.”
          </p>
          <p className="mt-4 font-semibold text-blue-800 dark:text-yellow-400">— Mrs. O.O. Adeleke, School Head</p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="px-6 py-20 bg-gray-100 dark:bg-neutral-900">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="mb-12 text-4xl font-bold text-gray-800 dark:text-white">Why Choose Us?</h2>
          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                icon: <FaChalkboardTeacher className="text-4xl text-blue-800" />,
                title: 'Certified Teachers',
                desc: 'Passionate and qualified educators in every classroom.'
              },
              {
                icon: <FaGlobe className="text-4xl text-blue-800" />,
                title: 'Global Curriculum',
                desc: 'Blending national curriculum with international best practices.'
              },
              {
                icon: <FaShieldAlt className="text-4xl text-blue-800" />,
                title: 'Safe Environment',
                desc: '24/7 security and child-friendly facilities.'
              },
              {
                icon: <FaCheckCircle className="text-4xl text-blue-800" />,
                title: 'Moral Discipline',
                desc: 'Christian values, leadership, and ethics.'
              },
            ].map((item, index) => (
              <div key={index} className="p-6 bg-white shadow-md dark:bg-neutral-800 rounded-xl hover:shadow-xl">
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">{item.title}</h3>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Virtual Tour (Image or Video) */}
      <section className="px-6 py-16 bg-white dark:bg-gray-800">
        <div className="grid items-center max-w-6xl gap-12 mx-auto lg:grid-cols-2">
          <img
            src="/images/school_img_2.jpg"
            alt="Virtual Tour"
            className="w-full rounded-lg shadow-lg"
          />
          <div>
            <h2 className="mb-4 text-3xl font-bold text-gray-800 dark:text-white">Take a Virtual Tour 🎥</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Explore our classrooms, laboratories, sports areas, and library. We provide everything your child needs to excel.
            </p>
            <a
              href="#"
              className="font-semibold text-blue-600 hover:underline dark:text-yellow-400"
            >
              Watch Video Tour →
            </a>
          </div>
        </div>
      </section>

      {/* How to Apply */}
      <section className="px-6 py-16 text-center bg-blue-50 dark:bg-blue-900">
        <h2 className="mb-6 text-3xl font-bold text-blue-900 dark:text-white">Admission Process 📋</h2>
        <ul className="max-w-2xl mx-auto space-y-4 text-lg text-left text-gray-700 list-disc list-inside dark:text-gray-100">
          <li>Visit or fill the online application form.</li>
          <li>Submit two passport photos and recent report cards.</li>
          <li>Attend entrance assessment and oral interview.</li>
          <li>Wait for confirmation from the school admin office.</li>
        </ul>
      </section>

      {/* Stats Section */}
      <section className="py-16 text-center bg-white dark:bg-gray-900">
        <div className="grid max-w-6xl gap-8 mx-auto sm:grid-cols-2 lg:grid-cols-4">
          {[
            { number: '1,250+', label: 'Students Enrolled' },
            { number: '35+', label: 'Qualified Teachers' },
            { number: '100%', label: 'WAEC Pass Rate' },
            { number: '12+', label: 'Years of Excellence' }
          ].map((stat, index) => (
            <div key={index}>
              <p className="text-4xl font-bold text-blue-800 dark:text-yellow-400">{stat.number}</p>
              <p className="text-lg text-gray-700 dark:text-gray-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 text-center bg-yellow-100 dark:bg-yellow-600">
        <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-white">Your Child Deserves the Best</h2>
        <p className="mb-6 text-gray-700 dark:text-white">Secure a seat at Blessed Montessori now before the slots are filled.</p>
        <button
          onClick={() => window.location.href = '/admission-form'}
          className="px-8 py-4 font-medium text-white transition bg-blue-700 rounded-lg hover:bg-blue-800"
        >
          Begin Admission Application
        </button>
      </section>

      <Footer />
    </>
  );
};

export default AdmissionPage;
